// Pausa temporária de interface. Mantém os dados e as configurações do backend
// para retomar a gamificação quando ela voltar a fazer parte do produto.
export function isFeatureVisible(flag: string): boolean {
  return flag !== "gamification";
}
